import React, { useEffect } from "react";
import { formatNumber } from "@/util/sums";
import ColFormValueSlider from "./ColFormValueSlider";
import { useController, useFormContext, useWatch } from "react-hook-form";
import ControlledFormField from "@/model/interface/ControllerRangeSlider";
import clamp from "@/util/clamp";
import { CalculatorField } from "@/model/interface/CalculatorTypes";

const upgradeBudgetDefault = 400000;
const getUpgradeBudgetFields = (depsArray: number[], ownValue: number) => {
  const [_homeValue] = depsArray;

  const homeValue = _homeValue;

  const minAmount = homeValue * 0.75;
  const maxAmount = homeValue * 0.95;

  const newBuyerBankShareValue = homeValue * 0.85;
  const newFintreeShareValue = ownValue ? homeValue - ownValue : homeValue - newBuyerBankShareValue;

  return {
    minAmount,
    maxAmount,
    value: clamp(newBuyerBankShareValue, minAmount, maxAmount),
    rightValue: newFintreeShareValue,
  };
};

const fieldName = CalculatorField.UpgradeBudget;
const fieldsWatched = [CalculatorField.HomeValue];
const UpgradeBudget: React.FC<ControlledFormField> = ({ fieldPrefix }) => {
  const targetName = [fieldPrefix, fieldName].filter(Boolean).join(".");
  const dependencies = fieldPrefix ? fieldsWatched.map((field) => `${fieldPrefix}.${field}`) : fieldsWatched;

  const { control, setValue } = useFormContext();
  const depsArray = useWatch({ control, name: dependencies });

  const { field } = useController({
    control,
    name: targetName,
    defaultValue: upgradeBudgetDefault,
  });

  const { value, rightValue, ...minMaxParams } = getUpgradeBudgetFields(depsArray, field.value);

  useEffect(() => {
    if (!value) return;
    console.log("useEffect", depsArray, value);
    setValue(targetName, value);
  }, [depsArray]);

  return (
    <ColFormValueSlider
      title="Budget"
      step={1000}
      value={field.value}
      {...minMaxParams}
      leftColumnValue={field.value}
      leftColumnLabel="You + Bank"
      leftColumnFormatFunction={(value) => `$${formatNumber(value, 0, true)}`}
      rightColumnValue={rightValue}
      rightColumnLabel="Fintree"
      rightColumnFormatFunction={(value) => `$${formatNumber(value, 0, true)}`}
      onChange={field.onChange}
      onFinalChange={field.onChange}
    />
  );
};

export default UpgradeBudget;
